export const DENY_GRANT = 'denied';
export const ALLOW_GRANT = 'granted';
export const ALLOW_LOCATIONS = ['us', 'nz', 'au'];

// Transcend consent regimes that should default to denied GA consent on init.
// CPRA (California) requires opt-in before granting ad/analytics consent.
export const GA_DENY_DEFAULT_REGIMES = ['CPRA'];
// Transcend consent regimes that should default to granted GA consent on init.
export const GA_ALLOW_DEFAULT_REGIMES = ['US_OTHER', 'US_DNSS'];
